import React from "react";
import { Text, Tooltip, Spinner } from "@chakra-ui/react";
import { useCodexCode } from "./hooks/useCodexCode"; // Adjust the import path as needed

const CodexLookupText = ({ label, version, codelist, codeValue, fontSize = "sm" }) => {
  const { code, loading } = useCodexCode(version, codelist, codeValue);

  if (!codeValue) return null;
  if (loading) return <Spinner size="xs" />;

  const description = code?.description1 || "Unknown";

  return (
    <Tooltip label={`Code: ${codeValue}`} aria-label="code tooltip">
      <Text fontSize={fontSize}>
        {label ? `${label}: ` : ""}
        {description}
      </Text>
    </Tooltip>
  );
};

export default CodexLookupText;
